<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Existing Client</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Existing Client</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <Dropdown @change="companyChanged" v-model="company" :options="companies" optionLabel="name" dataKey="value" placeholder="Company" :required="true" :filter="true" filterPlaceholder="Company" />
        <ion-item>
            <ion-label position="floating">Client <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet"  v-model="clientId">
                <ion-select-option v-for="(client,i) of clients" :key="i" :value="client.id">{{client.client_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship Name <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="shipName"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Power Source Type <span class="required">*</span></ion-label>
            <ion-input mode="ios" :disabled="true" v-model="powerSourceType"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">M Number <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="mNumber"></ion-input>
        </ion-item>
         <ion-item>
            <ion-label position="floating">Ship Type <span class="required">*</span></ion-label>
            <ion-select mode="ios" @IonChange="shipTypeChanged" interface="action-sheet" v-model="shipType">
                <ion-select-option v-for="(shipType,i) of shipTypes" :key="i" :value="shipType.id">{{shipType.ship_type_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Ship Capacity <span class="required">*</span></ion-label>
          <ion-text>
            Ship Capacity
          </ion-text>
            <ion-item v-for="(unit,i) of units" :key="i">
              <ion-label position="floating">{{unit.unit_name}} <span class="required">*</span></ion-label>
              <ion-input mode="ios" v-model="shipCapacity[''+unit.id]" type="number"></ion-input>
            </ion-item>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship Category</ion-label>
            <ion-select mode="ios" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="shipCategory">
                <ion-select-option v-for="(shipCategory,i) of shipCategories" :key="i" :value="shipCategory.id">{{shipCategory.ship_category_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Build Year</ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="buildYear">
                <ion-select-option v-for="(year,i) of years" :key="i" :value="year">{{year}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Draft Unit <span class="required">*</span></ion-label>
            <ion-select mode="ios" v-model="maxDraftUnit">
                <ion-select-option value="Feet">Feet</ion-select-option>
                <ion-select-option value="Meter">Meter</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Draft <small>(in {{maxDraftUnit}})</small> <span class="required">*</span></ion-label>
          <ion-input mode="ios"  v-model="maxDraft" type="number"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Length Unit <span class="required">*</span></ion-label>
            <ion-select mode="ios" v-model="lengthUnit">
                <ion-select-option value="Feet">Feet</ion-select-option>
                <ion-select-option value="Meter">Meter</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Length <small>(in {{lengthUnit}})</small> <span class="required">*</span></ion-label>
          <ion-input mode="ios"  v-model="length" type="number"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Beam Unit <span class="required">*</span></ion-label>
            <ion-select mode="ios" v-model="beamUnit">
                <ion-select-option value="Feet">Feet</ion-select-option>
                <ion-select-option value="Meter">Meter</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Beam <small>(in {{beamUnit}})</small> <span class="required">*</span></ion-label>
          <ion-input mode="ios"  v-model="beam" type="number"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Gross Tonnage <small>(in Ton)</small> </ion-label>
          <ion-input mode="ios"  v-model="grossTonnage" type="number"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Cargo Hold</ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="cargoHold">
                <ion-select-option v-for="(cargoHold,i) of cargoHolds" :key="i" :value="cargoHold">{{cargoHold}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Fitness Certificate</ion-label>
            <ion-select mode="ios"  v-model="fitnessCertificate" interface="action-sheet">
                <ion-select-option value="0">No</ion-select-option>
                <ion-select-option value="1">Yes</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Fitness Certificate Details <span v-if="fitnessCertificate==1" class="required">*</span></ion-label>
          <ion-textarea  v-model="fitnessCertificateDetails"></ion-textarea>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Fitness Certificate Expires <span v-if="fitnessCertificate==1" class="required">*</span></ion-label>
        <ion-datetime mode="ios"  v-model="fitnessExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
      </ion-item>
      <ion-item>
          <ion-label position="floating">Ship Products <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="alert" :interface-options="{cssClass:'custom-multiple-select-layout'}"  multiple v-model="product">
              <ion-select-option v-for="(product,i) of products" :key="i" :value="product.id">{{product.product_name}}</ion-select-option>
          </ion-select>
      </ion-item>
      <ion-item>
          <ion-label position="floating">Ship Routes <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="alert" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="route">
              <ion-select-option v-for="(route,i) of routes" :key="i" :value="route.id">{{route.route_name}}</ion-select-option>
          </ion-select>
      </ion-item>
      <ion-item>
          <ion-label position="floating">Ship Groups <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="alert" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="shipGroup">
              <ion-select-option v-for="(shipGroup,i) of shipGroups" :key="i" :value="shipGroup.id">{{shipGroup.ship_group_name}}</ion-select-option>
          </ion-select>
      </ion-item>
      <ion-item>
          <ion-label position="floating">Ship SMS Port Group <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="action-sheet" v-model="shipPortGroup">
              <ion-select-option v-for="(shipPortGroup,i) of shipPortGroups" :key="i" :value="shipPortGroup.id">{{shipPortGroup.port_group_name}}</ion-select-option>
          </ion-select>
      </ion-item>
      <ion-item>
          <ion-label position="floating">SOS Organization <span class="required">*</span></ion-label>
          <ion-select mode="ios" interface="alert" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="sosOrganization">
              <ion-select-option v-for="(sosOrganization,i) of sosOrganizations" :key="i" :value="sosOrganization.id">{{sosOrganization.sos_organization_name}}</ion-select-option>
          </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Survey Expire Date</ion-label>
        <ion-datetime mode="ios"  v-model="surveyExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Insurance Expire Date</ion-label>
        <ion-datetime mode="ios"  v-model="insuranceExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Bay Crossing Expire Date</ion-label>
        <ion-datetime mode="ios"  v-model="bayCrossingExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Protocol Expire Date</ion-label>
        <ion-datetime mode="ios"  v-model="protocolExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
      </ion-item>
      <Dropdown v-model="port" :options="ports" optionLabel="name" placeholder="Instalation Port" :required="true" :filter="true" filterPlaceholder="Instalation Port" />
      <ion-item>
        <ion-label position="floating">Installation Date <span class="required">*</span></ion-label>
        <ion-datetime mode="ios"  v-model="installationDate" display-format="DD/MMM/YYYY hh:mm A" min="1950-01-01" max="2030-12-12"></ion-datetime>
      </ion-item>
      <ion-item>
              <ion-label position="floating">Contact Person <span class="required">*</span></ion-label>
              <ion-input mode="ios"  v-model="contactPerson"></ion-input>
      </ion-item>
      <ion-item>
              <ion-label position="floating">Contact Person Mobile<span class="required">*</span></ion-label>
              <ion-input mode="ios"  v-model="contactPersonMobile" type="tel"></ion-input>
      </ion-item>
      <ion-item>
          <ion-label position="floating">Sales By <span class="required">*</span></ion-label>
          <!-- <ion-select mode="ios" interface="action-sheet" v-model="user">
              <ion-select-option v-for="(user,i) of users" :key="i" :value="user.id">{{user.name}}</ion-select-option>
          </ion-select> -->
          <ion-input mode="ios" :disabled="true"  v-model="salesByName" ></ion-input>
      </ion-item>
      <ion-item>
              <ion-label position="floating">Remarks</ion-label>
              <ion-input mode="ios"  v-model="remarks"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Device Price <span class="required">*</span></ion-label>
        <ion-input mode="ios" :disabled="true"  v-model="devicePrice" type="number"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Solar Panel Price <span class="required">*</span></ion-label>
        <ion-input mode="ios" :disabled="true" v-model="solarPanelPrice" type="number"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Installation Charge <span class="required">*</span></ion-label>
        <ion-input mode="ios" :disabled="true"  v-model="installationCharge" type="number"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Monthly Subscription Fee <span class="required">*</span></ion-label>
        <ion-input mode="ios" :disabled="true"  v-model="monthlySubscriptionFee" type="number"></ion-input>
      </ion-item>
      <ion-item v-if="!(shipName=='' || shipName==null)">
        <ion-button @click="draftSave()" color="secondary">Save to Draft</ion-button>
      </ion-item>
      <ion-button expand="block" @click="save()" color="primary">Save</ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonButtons, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonInput, IonItem, IonLabel,IonSelect,IonSelectOption,IonDatetime,alertController, IonText, IonTextarea } from '@ionic/vue';
import Dropdown from './modules/Dropdown.vue';
import Loading from '../Loading';
import localforage from 'localforage';
export default {
  name: 'Existing Client',
  props:[
      'draftId',
      'sale_id'
  ],
  data(){
    return {
      saleId:null,
      companyId:'',
      clientId:'',
      shipName:'',
      mNumber:'',
      shipCapacity:[],
      buildYear:'',
      maxDraft:'',
      length:'',
      beam:'',
      maxDraftUnit:'Feet',
      lengthUnit:'Feet',
      beamUnit:'Feet',
      grossTonnage:'',
      cargoHold:'',
      fitnessCertificate:'',
      fitnessCertificateDetails:'',
      fitnessExpireDate:'',
      surveyExpireDate:'',
      insuranceExpireDate:'',
      bayCrossingExpireDate:'',
      protocolExpireDate:'',
      installationDate:'',
      contactPerson:'',
      contactPersonMobile:'',
      remarks:'',
      years:[],
      cargoHolds:[],
      shipType:null,
      shipTypes:[],
      shipCategory:[],//multiple
      shipCategories:[],
      products:[],
      product:[], //multiple
      routes:[],
      route:[], //multiple
      shipGroups:[],
      shipGroup:[], //multiple
      shipPortGroups:[],
      shipPortGroup:null,
      sosOrganizations:[],
      sosOrganization:[], //multiple
      ports:[],
      port:null,
      users:[],
      user:null,
      salesByName:"",
      units:[],
      devicePrice:null,
      monthlySubscriptionFee:null,
      installationCharge:null,
      companies:[],
      company:'',
      clients:[],
      powerSourceType:null,
      solarPanelPrice:null
    }
  },
  created(){
    const drafts= localforage.createInstance({
        driver: [
          localforage.INDEXEDDB,
          localforage.LOCALSTORAGE,
        ],
        name:'drafts'
      });
    if(this.draftId!=''){
      drafts.getItem(this.draftId,  (err, value) =>{
        const data=JSON.parse(value.data);
        for(const ob in data){
          this[ob]=data[ob];
        }
      });
    }
    for(let i=new Date().getFullYear(); i>=1993;i--){
      this.years.push(i);
    }
    for(let i=0;i<=10;i++){
      this.cargoHolds.push(i+" Compartment");
    }
    this.$http.get('getSale/'+this.sale_id).then(response=>{
      this.installationCharge=response.data.installation_charge_per_ship;
      this.monthlySubscriptionFee=response.data.monthly_subscription_fee_per_ship;
      this.devicePrice=response.data.device_price_per_ship;
      this.user=response.data.sales_by.id;
      this.salesByName=response.data.sales_by.name;
      this.saleId=this.sale_id;
      this.powerSourceType=response.data.power_source_type;
      this.solarPanelPrice=response.data.solar_panel_price_per_ship;
      const coms=[];
        for(const com of response.data.companies){
            coms.push({
                name:com.company_name,
                value:com.id
            });
        }
        this.companies=coms;
    });
    this.$http.get('getShipType',).then(response=>{
      this.shipTypes=response.data;
    });
    this.$http.get('getShipCategory',).then(response=>{
      this.shipCategories=response.data;
    });
    this.$http.get('getProduct',).then(response=>{
      this.products=response.data;
    });
    this.$http.get('getRoute',).then(response=>{
      this.routes=response.data;
    });
    this.$http.get('getShipGroup',).then(response=>{
      this.shipGroups=response.data;
    });
    this.$http.get('getPortGroup',).then(response=>{
      this.shipPortGroups=response.data;
    });
    this.$http.get('getSOSOrganization',).then(response=>{
      this.sosOrganizations=response.data;
    });
    // this.$http.get('getUnit',).then(response=>{
    //   this.units=response.data;
    // });
    this.$http.get('getPort',).then(response=>{
      this.ports=[];
      for(const port of response.data ){
        this.ports.push({
          name:port.port_name,
          value:port.id
        });
      }
      // this.ports=response.data;
    });
    this.$http.get('getUser',).then(response=>{
      this.users=response.data;
    });
  },
  methods:{
    clearDateTime(event){
      event.target.value='';
    },
    removeTimeString(date){
      if(date=='' || date==null){
        return '';
      }
      return new Date(date).toISOString().split('T')[0];
    },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async companyChanged(){
        const loading = await Loading.presentLoading('Loading');
        this.companyId=this.company.value;
        this.clientId=null;
        this.$http.get('getClient',{params:{id:this.company.value}}).then(response=>{
            this.clients=response.data;
            loading.dismiss();
        });
    },
    convertToFeet(val,unit){
      if(unit=="Feet"){
        return val;
      }else{
        return val * 3.28;
      }
    },
    async save(){
      const shipCapacity=[];
      const keys= Object.keys(this.shipCapacity);
      for(const key of keys){
        shipCapacity.push('"'+key+'":"'+this.shipCapacity[key]+'"');
      }
      if(keys.length==0){
        for(const unit of this.units){
          shipCapacity.push('"'+unit.id+'":""');
        }
      }
      let shipCapacity_=shipCapacity.join(',');
      shipCapacity_=JSON.parse(`{`+shipCapacity_+`}`);
      
      // for(const capasity,i of this.shipCapacity){
      //   shipCapacity[i]=capasity;
      // }
      // console.log(shipCapacity);
      // console.log(JSON.stringify(shipCapacity));
      if(this.clientId=='' || this.clientId==null){
        this.presentAlert('Client ID');
        return;
      }
      if(this.shipName=='' || this.shipName==null){
        this.presentAlert('Ship Name');
        return;
      }
      if(this.mNumber=='' || this.mNumber==null){
        this.presentAlert('M Number');
        return;
      }
      for(const unit of this.units){
        if(this.shipCapacity[unit.id]=='' || this.shipCapacity[unit.id]==null){
          this.presentAlert(unit.unit_name);
          return;
        }
      }
      if(this.shipType=='' || this.shipType==null){
        this.presentAlert('Ship Type');
        return;
      }
      if(this.maxDraft=='' || this.maxDraft==null){
        this.presentAlert('Draft');
        return;
      }
      if(this.length=='' || this.length==null){
        this.presentAlert('Length');
        return;
      }
      if(this.beam=='' || this.beam==null){
        this.presentAlert('Beam');
        return;
      }
      if(this.fitnessCertificate==1 && (this.fitnessCertificateDetails=='' || this.fitnessCertificateDetails==null)){
        this.presentAlert('Fitness Certificate Details');
        return;
      }else if(this.fitnessCertificate==1 && this.fitnessCertificateDetails.length<6){
        this.presentResponseAlert('Alert','Fitness Certificate Details must be at least 6 Charecters');
        return;
      }
      if(this.fitnessCertificate==1 && (this.fitnessExpireDate=='' || this.fitnessExpireDate==null)){
        this.presentAlert('Fitness Certificate Expire Date');
        return;
      }
      if(this.product==null || this.product.length==0){
        this.presentAlert('Ship Products');
        return;
      }
      if(this.route==null || this.route.length==0){
        this.presentAlert('Ship Routes');
        return;
      }
      if(this.shipGroup==null || this.shipGroup.length==0){
        this.presentAlert('Ship Groups');
        return;
      }
      if(this.shipPortGroup=='' || this.shipPortGroup==null){
        this.presentAlert('Ship SMS Port Group');
        return;
      }
      if(this.sosOrganization==null || this.sosOrganization.length==0){
        this.presentAlert('SOS Organization');
        return;
      }
      if(this.port=='' || this.port==null){
        this.presentAlert('Instalation Port');
        return;
      }
      if(this.installationDate=='' || this.installationDate==null){
        this.presentAlert('Installation Date');
        return;
      }
      if(this.contactPerson=='' || this.contactPerson==null){
        this.presentAlert('Contact Person');
        return;
      }
      if(this.contactPersonMobile=='' || this.contactPersonMobile==null){
        this.presentAlert('Contact Person Mobile');
        return;
      }else if(this.contactPersonMobile.length!=11){
        this.presentResponseAlert('Alert','Contact Person Mobile must be 11 digit');
        return;
      }
      if(this.user=='' || this.user==null){
        this.presentAlert('Sales By');
        return;
      }
      if(this.devicePrice != 0 && (this.devicePrice=='' || this.devicePrice==null)){
        this.presentAlert('Device Price');
        return;
      }
      if(this.installationCharge !=0 && (this.installationCharge=='' || this.installationCharge==null)){
        this.presentAlert('Installation Charge');
        return;
      }
      if(this.monthlySubscriptionFee != 0 && (this.monthlySubscriptionFee=='' || this.monthlySubscriptionFee==null)){
        this.presentAlert('Monthly Subscription Fee');
        return;
      }
      const data={
        'sale_id':this.sale_id,
        'client_id':this.clientId,
        'client_name':this.clientName,
        'company_name':this.companyName,
        'company_designation':this.designation,
        'ship_name':this.shipName,
        'm_number':this.mNumber,
        'capacity':shipCapacity_,
        'ship_type_id':this.shipType,
        'ship_category_id':this.shipCategory,
        'build_year':this.buildYear,
        'max_draft_ft':this.convertToFeet(this.maxDraft,this.maxDraftUnit),
        'length':this.convertToFeet(this.length,this.lengthUnit),
        'beam':this.convertToFeet(this.beam,this.beamUnit),
        'gross_tonnage':this.grossTonnage,
        'cargo_hold':this.cargoHold,
        'fitness_certificate':this.fitnessCertificate,
        'fitness_certificate_details':this.fitnessCertificateDetails,
        'fitness_expire_date':this.removeTimeString(this.fitnessExpireDate),
        'product_id':this.product,
        'route_id':this.route,
        'ship_group_id':this.shipGroup,
        'port_group_id':this.shipPortGroup,
        'sos_organization_id':this.sosOrganization,
        'survey_expire_date':this.removeTimeString(this.surveyExpireDate),
        'insurance_expire_date':this.removeTimeString(this.insuranceExpireDate),
        'bay_crossing_expire_date':this.removeTimeString(this.bayCrossingExpireDate),
        'protocol_expire_date':this.removeTimeString(this.protocolExpireDate),
        'installation_date':this.installationDate,
        'contact_person':this.contactPerson,
        'contact_person_mobile':this.contactPersonMobile,
        'port_id':this.port!=null?this.port.value:'',
        'sales_by':this.user,
        'remarks':this.remarks,
        'device_price':this.devicePrice,
        'installation_charge':this.installationCharge,
        'monthly_subscription_fee':this.monthlySubscriptionFee,
        'power_source_type':this.powerSourceType,
        'solar_panel_price':this.solarPanelPrice,
        'username':window.localStorage.username,
        'password':window.localStorage.password,
      };
      // console.log(data);
      this.$http.post('requisitionAddForExistingClient',data).then(async response=>{
        if(response.status==200){
          this.presentResponseAlert('Success','Submitted Successfull');
          this.$router.replace('/all-sales');
          this.companyName='';
          this.clientName='';
          this.clientId='';
          this.mobile='';
          this.designation='';
          this.shipName='';
          this.mNumber='';
          this.shipCapacity=[];
          this.buildYear='';
          this.maxDraft='';
          this.length='';
          this.beam='';
          this.grossTonnage='';
          this.cargoHold='';
          this.fitnessCertificate='';
          this.fitnessCertificateDetails='';
          this.fitnessExpireDate='';
          this.surveyExpireDate='';
          this.insuranceExpireDate='';
          this.bayCrossingExpireDate='';
          this.protocolExpireDate='';
          this.installationDate='';
          this.contactPerson='';
          this.contactPersonMobile='';
          this.remarks='';
          this.shipType=null;
          this.shipCategory=[];//multiple
          this.product=[]; //multiple
          this.route=[]; //multiple
          this.shipGroup=[]; //multiple
          this.shipPortGroup=null;
          this.sosOrganization=[]; //multiple
          this.port=null;
          this.user=null;
          this.devicePrice=null;
          this.installationCharge=null;
          this.monthlySubscriptionFee=null;
          this.powerSourceType=null;
          this.solarPanelPrice=null;
          if(this.draftId!=''){
            const drafts= await localforage.createInstance({
                driver: [
                localforage.INDEXEDDB,
                localforage.LOCALSTORAGE,
                ],
                name:'drafts'
            });
            drafts.removeItem(this.draftId);
          }
        }else{
          let errors= response.data.errors;
          errors=errors.join('<br>');
          this.presentResponseAlert('Failed',errors);
        }
      });      
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
    shipTypeChanged(){
      for(const shipType of this.shipTypes){
        if(this.shipType==shipType.id){
          this.units=shipType.units;
          break;
        }
      }
    },
    draftSave(){
      if(this.shipName=='' || this.shipName==null){
        this.presentAlert('Ship Name');
        return;
      }
      const drafts= localforage.createInstance({
        driver: [
          localforage.INDEXEDDB,
          localforage.LOCALSTORAGE,
        ],
        name:'drafts'
      });
      const uniqId=this.draftId!=''?this.draftId:"draft-"+Math.floor(Math.random() * 100000);
      drafts.setItem(uniqId,{
        title:this.shipName,
        type:2,
        data:JSON.stringify(this.$data),
        time:new Date().getTime()
      });
      this.presentResponseAlert('Success','Client Drafted Successfull');
      this.$router.replace('/drafts');
          this.companyName='';
          this.clientName='';
          this.clientId='';
          this.mobile='';
          this.designation='';
          this.shipName='';
          this.mNumber='';
          this.shipCapacity=[];
          this.buildYear='';
          this.maxDraft='';
          this.length='';
          this.beam='';
          this.grossTonnage='';
          this.cargoHold='';
          this.fitnessCertificate='';
          this.fitnessCertificateDetails='';
          this.fitnessExpireDate='';
          this.surveyExpireDate='';
          this.insuranceExpireDate='';
          this.bayCrossingExpireDate='';
          this.protocolExpireDate='';
          this.installationDate='';
          this.contactPerson='';
          this.contactPersonMobile='';
          this.remarks='';
          this.shipType=null;
          this.shipCategory=[];//multiple
          this.product=[]; //multiple
          this.route=[]; //multiple
          this.shipGroup=[]; //multiple
          this.shipPortGroup=null;
          this.sosOrganization=[]; //multiple
          this.port=null;
          this.user=null;
          this.devicePrice=null;
          this.monthlySubscriptionFee=null;
          this.powerSourceType=null;
          this.solarPanelPrice=null;
    }
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonInput,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    Dropdown,
    IonDatetime,
    IonText,
    IonTextarea

  }
  
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
</style>
